import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/blackbear.png";
import { Facebook, Twitter, Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0e0e0e] dark:bg-slate-900 text-gray-300 dark:text-gray-300 px-4 sm:px-6 pt-12 pb-8 font-[Inter] transition-colors duration-300">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 border-b border-gray-800 dark:border-slate-700 pb-10">
        {/* Logo + Mission */}
        <div>
          <img src={logo} alt="Blackbear Logo" className="w-14 h-14 mb-4" />
          <h2 className="text-xl font-bold font-[DM Sans] text-white dark:text-white">
            Blackbear Technologies
          </h2>
          <p className="text-sm text-gray-400 dark:text-gray-400 mt-2 leading-relaxed">
            Empowering industries with smart software, automation, and AI-driven innovation.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <h3 className="text-sm font-semibold text-white dark:text-white uppercase tracking-wide mb-4">Navigation</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-blue-400 dark:hover:text-blue-300 transition">Services</Link></li>
            <li><Link to="/projects" className="hover:text-blue-400 dark:hover:text-blue-300 transition">Projects</Link></li>
            <li><Link to="/about" className="hover:text-blue-400 dark:hover:text-blue-300 transition">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-blue-400 dark:hover:text-blue-300 transition">Contact</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h3 className="text-sm font-semibold text-white dark:text-white uppercase tracking-wide mb-4">Legal</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-blue-400 dark:hover:text-blue-300 transition">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-blue-400 dark:hover:text-blue-300 transition">Terms of Service</Link></li>
            <li><Link to="/cookies" className="hover:text-blue-400 dark:hover:text-blue-300 transition">Cookie Policy</Link></li>
          </ul>
        </div>

        {/* Social */}
        <div>
          <h3 className="text-sm font-semibold text-white dark:text-white uppercase tracking-wide mb-4">Connect With Us</h3>
          <div className="flex gap-4 mb-3">
            <a href="https://www.instagram.com/blackbeartechnologies" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 dark:hover:text-blue-300 transition">
              <Instagram size={20} />
            </a>
            <a href="https://twitter.com/blackbeartech" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 dark:hover:text-blue-300 transition">
              <Twitter size={20} />
            </a>
            <a href="https://www.facebook.com/BlackbearTechnologies" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 dark:hover:text-blue-300 transition">
              <Facebook size={20} />
            </a>
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Stay updated on features, launches, and insights.
          </p>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="text-center text-xs text-gray-600 dark:text-gray-400 mt-6">
        &copy; {new Date().getFullYear()} Blackbear Technologies Inc. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
